module.exports = __webpack_public_path__ + "static/img/智能仓储.d6d94f1f.jpeg";